import type { FormattedMission } from '@library/types/missions';

type CreateMissionStepSummaryProps = {
  mission?: FormattedMission;
};

export const CreateMissionStepSummary = ({
  mission = undefined
}: CreateMissionStepSummaryProps) => {
  return (
    mission && (
      <div className="py-2">
        <div className="border-stankonia-100 border-l-2 px-2">
          <h3 className="text-soClean-100 text-base leading-6">
            {mission.name}
          </h3>
          <p className="text-soClean-160 text-sm leading-6">
            {mission.description}
          </p>
        </div>
      </div>
    )
  );
};
